var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSignup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 42,
    viewBox: "0 0 155 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7444_2561)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 40,
    fill: "#F5F5F5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 152.5,
    height: 39.5,
    stroke: "black",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1387 25H24.7129V15H26.1387V23.5742H31.1387V25ZM37.916 25H33.6289V24.2871H32.916V23.5742H32.2031V22.8613H31.4902V17.1436H32.2031V16.4307H32.916V15.7178H33.6289V15H37.916V15.7178H38.6289V16.4307H39.3467V17.1436H40.0596V22.8613H39.3467V23.5742H38.6289V24.2871H37.916V25ZM34.3467 23.5742H37.2031V22.8613H37.916V22.1436H38.6289V17.8613H37.916V17.1436H37.2031V16.4307H34.3467V17.1436H33.6289V17.8613H32.916V22.1436H33.6289V22.8613H34.3467V23.5742ZM47.2031 25H43.6289V24.2871H42.916V23.5742H42.2031V22.8613H41.4902V17.1436H42.2031V16.4307H42.916V15.7178H43.6289V15H47.916V15.7178H48.6289V16.4307H49.3467V17.1436H50.0596V18.5742H48.6289V17.8613H47.916V17.1436H47.2031V16.4307H44.3467V17.1436H43.6289V17.8613H42.916V22.1436H43.6289V22.8613H44.3467V23.5742H47.2031V22.8613H47.916V22.1436H48.6289V21.4307H46.4902V20H50.0596V25H48.6289V23.5742H47.916V24.2871H47.2031V25ZM55.7676 25H54.3418V15H55.7676V25ZM58.6191 25H57.1934V15H59.332V16.4307H60.0498V17.8613H60.7627V19.2871H61.4756V20.7178H62.1934V22.1436H62.9062V15H64.332V25H62.1934V23.5742H61.4756V22.1436H60.7627V20.7178H60.0498V19.2871H59.332V17.8613H58.6191V25ZM69.6885 25H68.6191V23.5742H69.332V22.1436H70.0449V20.7178H70.7578V19.2871H71.4756V17.8613H72.1885V16.4307H72.9014V15H73.6191V13.5742H74.6885V15H73.9756V16.4307H73.2578V17.8613H72.5449V19.2871H71.832V20.7178H71.1191V22.1436H70.4014V23.5742H69.6885V25ZM85.3965 25H80.3965V24.2871H79.6836V23.5742H78.9707V22.1436H80.3965V22.8613H81.1094V23.5742H84.6836V22.8613H85.3965V21.4307H84.6836V20.7178H81.1094V20H79.6836V19.2871H78.9707V16.4307H79.6836V15.7178H80.3965V15H85.3965V15.7178H86.1094V16.4307H86.8271V17.8613H85.3965V17.1436H84.6836V16.4307H81.1094V17.1436H80.3965V18.5742H81.1094V19.2871H84.6836V20H86.1094V20.7178H86.8271V23.5742H86.1094V24.2871H85.3965V25ZM89.6738 25H88.248V15H89.6738V25ZM96.8125 25H93.2383V24.2871H92.5254V23.5742H91.8125V22.8613H91.0996V17.1436H91.8125V16.4307H92.5254V15.7178H93.2383V15H97.5254V15.7178H98.2383V16.4307H98.9561V17.1436H99.6689V18.5742H98.2383V17.8613H97.5254V17.1436H96.8125V16.4307H93.9561V17.1436H93.2383V17.8613H92.5254V22.1436H93.2383V22.8613H93.9561V23.5742H96.8125V22.8613H97.5254V22.1436H98.2383V21.4307H96.0996V20H99.6689V25H98.2383V23.5742H97.5254V24.2871H96.8125V25ZM102.525 25H101.1V15H103.238V16.4307H103.956V17.8613H104.669V19.2871H105.382V20.7178H106.1V22.1436H106.812V15H108.238V25H106.1V23.5742H105.382V22.1436H104.669V20.7178H103.956V19.2871H103.238V17.8613H102.525V25ZM118.238 25H113.951V24.2871H113.238V23.5742H112.525V15H113.951V22.8613H114.664V23.5742H117.525V22.8613H118.238V15H119.664V23.5742H118.951V24.2871H118.238V25ZM122.525 25H121.1V15H126.812V15.7178H127.525V16.4307H128.238V20H127.525V20.7178H126.812V21.4307H122.525V25ZM122.525 20H126.1V19.2871H126.812V17.1436H126.1V16.4307H122.525V20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7444_2561",
    x: 0,
    y: 0,
    width: 155,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0316664 0 0 0 0 0.0316664 0 0 0 0 0.0316664 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7444_2561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7444_2561",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSignup);
export default __webpack_public_path__ + "static/media/loginSignup.360af8d2f77702b031c15d9890cd5766.svg";
export { ForwardRef as ReactComponent };